import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/detail-resi-notfound.png'
import _imports_1 from '@/assets/img/confirmation/package-cancel.png'


const _hoisted_1 = { id: "dialog-detail-resi" }
const _hoisted_2 = {
  class: "flex w-full justify-between items-center px-2 pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_3 = {
  key: 0,
  alt: "milsi-logo",
  src: "/img/milsi-logo.png",
  class: "",
  style: {"height":"25px"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "font-semibold text-xl text-black" }
const _hoisted_6 = { class: "font-semibold color-blue-grey" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Tekan ")
const _hoisted_8 = /*#__PURE__*/_createVNode("b", null, "Esc", -1)
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "sm:max-w-sm mx-auto"
}, null, -1)
const _hoisted_11 = { class: "sm:max-w-sm mx-auto text-center font-semibold" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Oops, data tidak ditemukan ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Coba lagi! ")
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "w-full text-left py-4"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Refund/Retur")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Batalkan")
const _hoisted_19 = {
  key: 1,
  class: "flex gap-4"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Batalkan Paket")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Selanjutnya")
const _hoisted_22 = {
  key: 2,
  class: "w-full justify-between flex items-center",
  style: {}
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Konfirmasi Resi")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Proses Transaksi")
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "color-primary font-normal mr-2 text-xl" }, "Grand Total", -1)
const _hoisted_27 = { class: "font-normal color-blue-grey text-sm text-left" }
const _hoisted_28 = { class: "color-primary font-bold text-3xl pb-1" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey text-sm" }, "*Sudah termasuk biaya tambahan dan diskon", -1)
const _hoisted_30 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_31 = { class: "grid  justify-items-center" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Kembali ")
const _hoisted_33 = { class: "content mt-4" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "container-img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "img-content"
  })
], -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "sub-title" }, " Apakah Anda yakin ingin membatalkan paket ini? Harap instruksikan kepada pengirim untuk buat pengiriman ulang jika paket dibatalkan! ", -1)
const _hoisted_36 = { class: "block my-4" }
const _hoisted_37 = {
  key: 0,
  class: "p-error"
}
const _hoisted_38 = { class: "flex gap-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentMilsi = _resolveComponent("ContentMilsi")
  const _component_ContentDefault = _resolveComponent("ContentDefault")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_DialogConfirm = _resolveComponent("DialogConfirm")
  const _component_Field = _resolveComponent("Field")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: _ctx.dialogDetailResi,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogDetailResi = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.isMiisi)
            ? (_openBlock(), _createBlock("img", _hoisted_3))
            : (_openBlock(), _createBlock("span", _hoisted_4, [
                _createVNode("h6", _hoisted_5, _toDisplayString((_ctx.onRefund) ? 'Refund / Retur Resi' : 'Detail Resi'), 1),
                _createVNode("small", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createTextVNode(" untuk menutup halaman " + _toDisplayString((_ctx.onRefund) ? 'Refund / Retur Resi' : 'Detail Resi'), 1)
                ])
              ])),
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hidedialogDetailResi()))
          })
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isValidData)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              (_ctx.onRefund)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    _createVNode(_component_Button, {
                      class: "btn-primary text-black mr-3 px-10 py-1",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Button, {
                      class: "btn-secondary text-black px-10 py-1",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hidedialogDetailResi()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.isMiisi)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode(_component_Button, {
                        class: "btn-red p-button-sm",
                        onClick: _ctx.onCancelPackage
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        class: "btn-primary text-black p-button-sm",
                        onClick: _ctx.onNext
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_22, [
                      (_ctx.isFromGuid && _ctx.data.FirstScanDate == null)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "btn-primary text-black mr-3 px-10 py-1",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitScanResi()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }, 512)), [
                            [_directive_focus]
                          ])
                        : (_ctx.module === 'delivery-draft')
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onProcessTrans()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock("div", _hoisted_25, [
                              _hoisted_26,
                              _createVNode("p", _hoisted_27, _toDisplayString(_ctx.data.JenisPembayaran.Nama), 1)
                            ])),
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_28, " Rp. " + _toDisplayString(new Number(_ctx.data.GrandTotal).toLocaleString("id-ID")), 1),
                        _hoisted_29
                      ])
                    ]))
            ], 64))
          : (_openBlock(), _createBlock("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _withDirectives(_createVNode(_component_Button, {
                  class: "btn-primary text-black mr-3 px-10 py-1",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hidedialogDetailResi()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                }, 512), [
                  [_directive_focus]
                ])
              ])
            ]))
      ]),
      default: _withCtx(() => [
        (_ctx.isValidData)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              (_ctx.isMiisi)
                ? (_openBlock(), _createBlock(_component_ContentMilsi, {
                    key: 0,
                    data: _ctx.data
                  }, null, 8, ["data"]))
                : (_openBlock(), _createBlock(_component_ContentDefault, {
                    key: 1,
                    data: _ctx.data,
                    onRefund: _ctx.onRefund,
                    dataAnsuransi: _ctx.dataAnsuransi
                  }, null, 8, ["data", "onRefund", "dataAnsuransi"]))
            ], 64))
          : (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("p", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.resMessage), 1)
              ])
            ]))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DialogConfirm, { ref: "refDialogConfirm" }, null, 512),
    _createVNode(_component_DialogConfirm, {
      ref: "refDialogCancelPackage",
      isMiisi: true
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_33, [
          _hoisted_34,
          _hoisted_35,
          _createVNode("div", _hoisted_36, [
            _createVNode(_component_Field, {
              as: "textarea",
              name: "reason",
              placeholder: "Masukkan alasan pembatalan",
              class: "p-inputtext p-component rounded-md w-full"
            }),
            (_ctx.metaFormReason.touched)
              ? (_openBlock(), _createBlock("small", _hoisted_37, _toDisplayString(_ctx.errorsFormReason.reason), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_38, [
            _createVNode(_component_Button, {
              type: "submit",
              class: "btn-primary w-full text-center",
              onClick: _ctx.onSubmitCancel,
              label: "Batalkan Paket"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "btn-secondary w-full",
              onClick: _ctx.onCloseDialogCancelPackage,
              label: "Kembali"
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}